import React from 'react';
import './FormGrid.css';

export type FormGridDensity = 'compact' | 'default' | 'comfortable';
export type FormGridWidth = 'date' | 'short' | 'medium' | 'long' | 'wide' | 'full';

const WIDTH_SPAN_MAP: Record<FormGridWidth, number> = {
  date: 2,
  short: 3,
  medium: 4,
  long: 6,
  wide: 8,
  full: 12,
};

export interface FormGridProps extends React.HTMLAttributes<HTMLDivElement> {
  density?: FormGridDensity;
  children: React.ReactNode;
}

export interface FormGridItemProps extends React.HTMLAttributes<HTMLDivElement> {
  width?: FormGridWidth;
  span?: number;
  children: React.ReactNode;
}

export const FormGrid: React.FC<FormGridProps> = ({
  density = 'default',
  className = '',
  children,
  ...props
}) => {
  const classNames = ['ui-form-grid', `ui-form-grid--${density}`, className].filter(Boolean).join(' ');
  return (
    <div className={classNames} {...props}>
      {children}
    </div>
  );
};

export const FormGridItem: React.FC<FormGridItemProps> = ({
  width = 'full',
  span,
  className = '',
  style,
  children,
  ...props
}) => {
  const resolvedSpan = Math.min(12, Math.max(1, span ?? WIDTH_SPAN_MAP[width]));
  const classNames = ['ui-form-grid__item', className].filter(Boolean).join(' ');
  return (
    <div
      className={classNames}
      style={{ '--ui-form-grid-span': resolvedSpan, ...style } as React.CSSProperties}
      {...props}
    >
      {children}
    </div>
  );
};

FormGrid.displayName = 'FormGrid';
FormGridItem.displayName = 'FormGridItem';
